import React from 'react';
import slug from 'constants/slug';
import { create } from 'api/environmentProtectionWorkApi';
import Message from 'rc-message';
// import * as _ from 'lodash';
import EnvironmentProtectionWorkForm from '../environment-protection-work-Form';
import PageLockHOC from 'hoc/pageLock';

@PageLockHOC(['environmentProtectionWork.view'])
export default class EnvironmentProtectionWorkCreate extends React.Component {
  static propTypes = {};

  state = {
    isLoaded: true,
    isLoading: false,
    facility: null,
    facilityId: ''
  };


  handelSubmit = async values => {
    this.setState({
      isLoading: true
    });
    const res = await create(_.pickBy(values, _.identity));
    if (res.success && res.data) {
      Message.success({ content: 'Thành Công' });
      this.props.history.push(slug.ENVIRONMENT_PROTECTION_WORK.VIEW_WITH_ID + res.data._id);
    }
    if (res.error) Message.error({ content: res.message });
  };

  render() {
    return (
      <div>
        {this.state.isLoaded && (
          <EnvironmentProtectionWorkForm
            slugBack={slug.FACILITY_PERMIT.LIST}
            facility={this.state.facility ? this.state.facility : null}
            handelSubmit={this.handelSubmit}
          />
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/environment-protection-work/environment-protection-work-Create/index.js